import React from "react";
import { AlertBanner } from "../alerts/AlertBanner";
import { HamburgerMenu } from "../ui/HamburgerMenu";
import { ProcedureInfo } from "../ui/ProcedureInfo";
import { StatusIcons } from "../ui/StatusIcons";

interface HeaderToolbarProps {
  userInitials?: string;
}

export const HeaderToolbar: React.FC<HeaderToolbarProps> = ({
  userInitials = "MC",
}) => {
  return (
    <header className="p-4 pr-8">
      <div className="flex items-center justify-between space-x-3">
        {/* Left Side */}
        <div className="flex items-center space-x-4">
          <HamburgerMenu />
          <ProcedureInfo />
        </div>

        {/* Middle Section - Alert Banner with Status Icons */}
        <div className="flex items-center flex-1">
          <AlertBanner />
          <StatusIcons />
        </div>

        {/* Right Side - User Initials */}
        <div className="flex items-center space-x-3">
          <div className="text-sm font-medium bg-crane-blue-gray h-12 w-12 flex items-center justify-center rounded-lg">
            {userInitials}
          </div>
        </div>
      </div>
    </header>
  );
};
